import React from "react";
import Div from "../lib/Div";
import {LinearGradient} from "expo-linear-gradient";
import Btn from "./Btn";

type GlassButtonProps = {
  overlayColor: string;
  borderColor: string;
  children?: React.ReactNode;
  disabled?: boolean;
  onPress?: () => void;
  opacity?: number;
  testID?: string;
};

const GlassButton = (props: GlassButtonProps) => {
  const {overlayColor, borderColor, children, disabled, opacity, testID} = props;
  return (
    <Btn disabled={disabled} opacity={opacity} overflow="hidden" bg="#000" onPress={props.onPress} testID={testID}>
      <Div rounded={6} borderWidth={2} borderColor={borderColor} bg={overlayColor}>
        <LinearGradient style={{flexDirection: 'row', alignItems: 'center', paddingHorizontal: 8, minHeight: 30}}
                        start={{x: 0.15, y: 0.1}} end={{x: 0.75, y: 0.85}}
                        colors={['rgba(255,255,255,0.20)', 'rgba(255,255,255,0.00)']}>
          {children}
        </LinearGradient>
      </Div>
    </Btn>
  );
};

export default GlassButton;
